export default __webpack_public_path__ + "72029b6f573c5e5fcd7d720a6d424f47.svg";